import { Component, OnInit } from '@angular/core';
import { ICentroCosto } from 'src/app/interfaces/centro-costo';
import { IPlant } from 'src/app/interfaces/plant';
import { CentroCostoService } from 'src/app/services/centro-costo.service';
import { PlantService } from 'src/app/services/plant.service';
import {Response} from "../../interfaces/response";
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CentroCostoSaveComponent } from './centro-costo-save/centro-costo-save.component'
@Component({
  selector: 'app-centro-costo',
  templateUrl: './centro-costo.component.html',
  styleUrls: ['./centro-costo.component.css']
})
export class CentroCostoComponent implements OnInit {

  texto: string;
  centroCosto: ICentroCosto[];
  plants: IPlant[];
  lastPage: number;
  nombre_ceco: number;
  sucursal: string;

  constructor(
    private centroCostoService: CentroCostoService,
    private plantService: PlantService,
    private ngbModalRef: NgbModal
  ) { }

  ngOnInit(): void {
    this.refresh();
    this.getSucursales();
  }

  refresh(currentPage = 1, param1=null , param2=null ) {
    this.centroCostoService.all(currentPage, param1, param2).subscribe(
      (res: Response) => {
        this.centroCosto = res.data;
        this.lastPage = res.meta.last_page;
      }
    )
  }
  getSucursales() {
    this.plantService.allRecords().subscribe(
      (res: Response) => {
        this.plants = res.data;
      }
    )
  }

  delete(orden_ceco: number) {
    if (confirm('Are you sure you want to delete this record?')) {
      this.centroCostoService.delete(orden_ceco).subscribe(
        res => {
          this.centroCosto = this.centroCosto.filter(el => el.orden_ceco !== orden_ceco);
        }
      );
    }
  }

  mostrarBootstrapModal(orden_ceco: number,tipo: string) {
    const opts = {
      windowClass: 'myCustomClass'
    };
//
    const modalRefNgBots = this.ngbModalRef.open(CentroCostoSaveComponent, opts);
//
    modalRefNgBots.componentInstance.id = orden_ceco;
    modalRefNgBots.componentInstance.tipo = tipo;
//
    modalRefNgBots.componentInstance.closeMyModal = () => {
      modalRefNgBots.close();
    }
//
    modalRefNgBots.componentInstance.salida.subscribe(res => {

     // this.texto = res;
      console.log('Recibo: ', res.success);
      if (res.success){
        alert("Grabado");
      }
      this.refresh();
      modalRefNgBots.close();
    });

  }



}
